import React, { ReactElement } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import constVars from '~/constants/constVars';
import { useAuth } from './contexts/AuthContext/AuthProvider';
import { Center, Loader } from '@qred/components-library';
import { SvcOnboardingAuthLoadingScreen } from './SvcOnboardingAuthLoadingScreen';
import { AuthProvider } from './enums';
import useQueryParams from './hooks/useQueryParams';

const ProtectedRoute = ({ ...props }: RouteProps): ReactElement => {
  const { isAuthenticated, isLoading, provider } = useAuth();
  const queryParams = useQueryParams();

  if (isLoading) {
    if (
      provider === AuthProvider.SVC_ONBOARDING &&
      queryParams.has('complete')
    ) {
      return <SvcOnboardingAuthLoadingScreen />;
    }

    return (
      <Center>
        <Loader size={'xxl'} />
      </Center>
    );
  }

  if (isAuthenticated) {
    return <Route {...props} />;
  }

  if (window.location.pathname !== constVars.ROUTE_DEFAULT) {
    const returnToValue = `${window.location.pathname}${window.location.search}`;
    sessionStorage.setItem('returnTo', returnToValue);
  }

  if (provider === AuthProvider.SVC_ONBOARDING) {
    return <Redirect to={`/${constVars.ROUTE_SVC_ONBOARDING_AUTH_ERROR}`} />;
  }

  return <Redirect to={`/${constVars.ROUTE_LOGIN}`} />;
};

export default ProtectedRoute;
